import { render } from "./ContentOther.vue?vue&type=template&id=f86ac44c"
import script from "./ContentOther.vue?vue&type=script&lang=js"
export * from "./ContentOther.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/help/ContentOther.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f86ac44c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f86ac44c', __exports__)) {
    api.reload('f86ac44c', __exports__)
  }
  
  module.hot.accept("./ContentOther.vue?vue&type=template&id=f86ac44c", () => {
    api.rerender('f86ac44c', render)
  })

}


export default __exports__